import { SalesItemBookingChannel } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import { GARAGE_ICON_NAME } from '../LeafLetMap/markers/facilityIcons';

/** Display order for multi-channel cells (mobile first, then stationary). */
export const SALES_ITEM_BOOKING_CHANNEL_ORDER: SalesItemBookingChannel[] = [
  SalesItemBookingChannel.MOBILE,
  SalesItemBookingChannel.STATIONARY
];

export const SALES_ITEM_BOOKING_CHANNEL_ICON: Record<SalesItemBookingChannel, NoddiIconName> = {
  [SalesItemBookingChannel.MOBILE]: 'Truck',
  [SalesItemBookingChannel.STATIONARY]: GARAGE_ICON_NAME
};

/** Short hover copy: channel name + what it means for listing. */
export const SALES_ITEM_BOOKING_CHANNEL_TOOLTIP: Record<SalesItemBookingChannel, string> = {
  [SalesItemBookingChannel.MOBILE]: 'Mobile — home / address booking',
  [SalesItemBookingChannel.STATIONARY]: 'Stationary — service-center booking'
};
